module.exports = __webpack_public_path__ + "static/media/pic3.84a024c3.jpg";